export default {
  header: {
    title: "Architecture Templates",
    subtitle: "Get started quickly with our preconfigured and ready-to-deploy templates"
  },
  search: {
    placeholder: "Search..."
  },
  filters: {
    allCategories: "All",
    allProviders: "All",
    allDifficulties: "All"
  },
  categories: {
    webApp: "Web App",
    microservices: "Microservices",
    dataProcessing: "Data Processing",
    serverless: "Serverless",
    network: "Network",
    security: "Security"
  },
  providers: {
    azure: "Azure",
    aws: "AWS",
    gcp: "GCP",
    multiCloud: "Multi-Cloud"
  },
  difficulties: {
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced"
  },
  stats: {
    templatesAvailable_one: "{{count}} template available",
    templatesAvailable_other: "{{count}} templates available"
  },
  card: {
    popular: "⭐ POPULAR",
    resources: "Resources:",
    deployment: "Deployment:",
    preview: "Preview",
    use: "Use"
  },
  emptyState: {
    title: "No templates found",
    subtitle: "Try modifying your search filters"
  },
  preview: {
    resources: "Resources",
    deployment: "Deployment",
    difficulty: "Difficulty",
    featuresTitle: "Included features",
    close: "Close",
    useTemplate: "Use this template"
  },
  alerts: {
    usingTemplate: "Using template: {{name}}"
  },
  templateData: {
    template1: {
      name: "3-Tier Web Application",
      description: "Classic architecture with frontend, backend API and database. Includes load balancer, auto-scaling and Redis cache.",
      features: [
        "Auto-scaling",
        "Load Balancer",
        "Redis Cache",
        "SQL Database",
        "CDN",
        "Application Insights"
      ]
    },
    template2: {
      name: "Microservices Infrastructure",
      description: "Microservices architecture with Kubernetes (AKS), Istio service mesh, and complete monitoring.",
      features: [
        "Kubernetes AKS",
        "Istio Service Mesh",
        "API Gateway",
        "Event Hub",
        "Container Registry",
        "Prometheus Monitoring"
      ]
    },
    template3: {
      name: "Serverless API",
      description: "Serverless REST API with Azure Functions, API Management and Cosmos DB for infinite scalability.",
      features: [
        "Azure Functions",
        "API Management",
        "Cosmos DB",
        "App Service Plan",
        "Key Vault",
        "Application Insights"
      ]
    },
    template4: {
      name: "Data Lake & Analytics",
      description: "Data pipeline with ingestion, transformation, storage and analysis. Includes Data Factory and Synapse Analytics.",
      features: [
        "Data Lake Storage",
        "Data Factory",
        "Synapse Analytics",
        "Stream Analytics",
        "Event Hubs",
        "Power BI"
      ]
    },
    template5: {
      name: "Hub-Spoke Network",
      description: "Hub-Spoke network topology with VPN Gateway, Firewall and ExpressRoute for hybrid connectivity.",
      features: [
        "Virtual Network",
        "VPN Gateway",
        "Azure Firewall",
        "ExpressRoute",
        "Network Security Groups",
        "Bastion"
      ]
    },
    template6: {
      name: "Enterprise Landing Zone",
      description: "Complete landing zone with governance, security and compliance for enterprise. Based on CAF.",
      features: [
        "Management Groups",
        "Policy",
        "RBAC",
        "Security Center",
        "Sentinel",
        "Log Analytics"
      ]
    },
    template7: {
      name: "E-Commerce Platform",
      description: "Complete e-commerce platform with product catalog, shopping cart, payment and order management.",
      features: [
        "EC2 Auto Scaling",
        "RDS MySQL",
        "ElastiCache",
        "CloudFront",
        "S3",
        "Lambda"
      ]
    },
    template8: {
      name: "ML Training Pipeline",
      description: "Complete pipeline for ML model training with SageMaker, S3 storage and automatic deployment.",
      features: [
        "SageMaker",
        "S3",
        "Lambda",
        "Step Functions",
        "ECR",
        "CloudWatch"
      ]
    },
    template9: {
      name: "Static Website",
      description: "Static website with CI/CD, hosted on S3 with CloudFront and SSL certificate.",
      features: [
        "S3",
        "CloudFront",
        "Route 53",
        "ACM Certificate",
        "CodePipeline",
        "CloudWatch"
      ]
    },
    template10: {
      name: "IoT Data Processing",
      description: "IoT architecture with real-time ingestion, processing and visualization of sensor data.",
      features: [
        "Cloud IoT Core",
        "Pub/Sub",
        "Dataflow",
        "BigQuery",
        "Cloud Storage",
        "Data Studio"
      ]
    },
    template11: {
      name: "Multi-Cloud DR",
      description: "Multi-cloud disaster recovery solution with Azure-AWS replication for high availability.",
      features: [
        "Site Recovery",
        "VPN",
        "Traffic Manager",
        "Route 53",
        "S3 Replication",
        "Monitoring"
      ]
    },
    template12: {
      name: "CI/CD Pipeline",
      description: "Complete CI/CD pipeline with automated tests, staging and blue-green deployment.",
      features: [
        "GitHub Actions",
        "Docker",
        "Kubernetes",
        "Terraform",
        "Monitoring",
        "Notifications"
      ]
    }
  }
};
